import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BorgService {

  public intensityLabels: any = {
    0: 'At Rest ',
    1: 'very light activity',
    2: 'light activity',
    3: 'light activity',
    4: 'Moderate intensity exercise(can talk, but not sing)',
    5: 'Moderate intensity exercise(can talk, but not sing)',
    6: 'Moderate intensity exercise(can talk, but not sing)',
    7: 'high intensity exercise (unable to talk much)',
    8: 'high intensity exercise (unable to talk much)',
    9: 'Very high intensity exercise',
    10: 'Maximum effort',
  };
  constructor() { }

  getIntensityLabel(score:number){
      return this.intensityLabels[score];
  }
}
